class ContainerStateType {
  constructor(code, chineseName, englishName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

export const CODE_NAME = 'ContainerStateType'

export const CANCELED = new ContainerStateType(0, '计划中', 'canceled')
export const OPERATING = new ContainerStateType(1, '已锁定', 'operating')
export const FINISHED = new ContainerStateType(2, '已装箱', 'finished')

export const CONTAINER_STATE_TYPES = [CANCELED, OPERATING, FINISHED]
